import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { SiteRoutes } from '@/routes'
import '@/i18n'
import '@/index.css'
import '@/portfolio.css'

const root = document.getElementById('root')!
const app = (
  <StrictMode>
    <BrowserRouter>
      <SiteRoutes />
    </BrowserRouter>
  </StrictMode>
)
if (root.dataset.prerenderedPath === window.location.pathname) {
  hydrateRoot(root, app)
} else {
  createRoot(root).render(app)
}
